import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import '../../Assets/CSS/events.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, useNavigate } from 'react-router-dom';
import Login from '../../components/auth/login/Login';
import './style.css';


const Events = ({ isAuthenticated }) => {
    const [events, setEvents] = useState([])
    const [showLoginModal, setShowLoginModal] = useState(false);
    const Navigate = useNavigate();
    useEffect(() => {
        fetchEvents();
    }, []);
     const handleCloseLogin = () => {
        // Close login modal
        setShowLoginModal(false);

    }
    const handleEventClick = (eventId) => {
          
        if (!isAuthenticated) {
            setShowLoginModal(true);
            return;
        }
        console.log("Clicked Event ID:", eventId); // Debugging


        Navigate(`/events/eventdetail/${eventId}`); // ✅ Correct eventId

    };



    const fetchEvents = async (date) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/event/allevents`,
            );
            const data = await response.json();
            setEvents(data);
            console.log(events);

        } catch (error) {
            console.error("Error fetching daily attendance data:", error);
        }
    };
    return (
        <div className="conatiner"
            style={{
                backgroundColor:'#401201',
                marginTop: isAuthenticated ? '160px' : '0px'
            }}
            >
        {showLoginModal && (<Login onClose={handleCloseLogin} loginopen={showLoginModal} />
            )}

            <div className="px-lg-5 px-3 ">
                <div className="d-flex justify-content-between align-items-center">
                    <h2 className="fw-bold heading " style={{ fontFamily: 'play', color: '#FFFFFF',paddingTop:'30px',paddingBottom:'30px' }}>Events</h2>
                    <Link to="/events" className="text-decoration-none fs-6 ">
                       <button className='see-all'> See All
                         <Icon icon="iconamoon:arrow-right-2" className="ms-1" />
                       </button>
                       
                    </Link>
                </div>
                <div>
                    <Swiper
                        navigation={true}
                        modules={[Navigation]}
                        className="mySwiper position-relative"
                        spaceBetween={30}  // Space between slides
                        breakpoints={{
                            320: {
                                slidesPerView: 1, // 1 item for small devices
                                spaceBetween: 20, // Space between items
                            },
                            768: {
                                slidesPerView: 2, // 2 items for medium devices
                                spaceBetween: 30, // Space between items
                            },
                            1024: {
                                slidesPerView: 3, // 3 items for large devices
                                spaceBetween: 30, // Space between items
                            },
                        }}
                    >

                        {events.map((event, index) => (
                            <SwiperSlide key={event.eventId}
                                style={{
                                    cursor: 'pointer',
                                }}>
                                <div onClick={() => handleEventClick(event.eventId)}>
                                    <div className="card h-100 w-100 gap-2 " style={{backgroundColor:'#401201'}}>
                                    <div className='blog-container'>
                                        <img
                                            src={event.eventImage[0]}
                                            className="card-img-top "
                                            style={{ height: '250px', borderRadius: '20px', overflow: 'hidden' }}
                                            alt={event.eventTitle}
                                        />
                                         <Icon icon="ri:focus-3-line" className='focus-icon '/>
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">{event.eventTitle}</h5>
                                            <p className="card-body">{event.eventDescription.slice(0, 100)}<span>...</span></p>
                                            <small className="text-muted" style={{ color: '#FFFFFF !important' }}>{new Date(event.createdAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</small>

                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}

                    </Swiper>
                </div>
            </div >
            
        </div>
    );
};

export default Events;
